export const sendAddToCart = data => {
	if (window.fbq) {
		window.fbq('track', 'AddToCart', data);
	}
};

export const sendAddToWishlist = data => {
	if (window.fbq) {
		window.fbq('track', 'AddToWishlist', data);
	}
};

export const sendContact = () => {
	if (window.fbq) {
		window.fbq('track', 'Contact');
	}
};

export const sendInitiateCheckout = data => {
	if (window.fbq) {
		window.fbq('track', 'InitiateCheckout', data);
	}
};

export const sendSearch = data => {
	if (window.fbq) {
		window.fbq('track', 'Search', data);
	}
};

export const sendPurchase = data => {
	if (window.fbq) {
		window.fbq('track', 'Purchase', data);
	}
};
